import React, { useContext, Fragment } from 'react'
import { Typography, Select, MenuItem } from '@material-ui/core'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'

export default function Year (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringDetailsFiltersContext)

  const years: Array<number> = []
  for (let year = moment().year() - 2; year <= moment().year(); year++) {
    years.push(year)
  }

  const handleChange = (event: any, value: any) => {
    setFilters({
      ...filters,
      date: {
        year: +value.props.value,
        month: filters.date.month,
        time_zone: filters.date.time_zone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Ano</Typography>
      <Select
          labelId="daily-monitoring-year-filter-label"
          id="daily-monitoring-year-filter"
          value={filters.date.year}
          onChange={handleChange}
        >
          {years.map((year: number) => <MenuItem key={year} value={year}>{year}</MenuItem>)}
        </Select>
    </Fragment>
  )
}
